import React, { useState } from 'react';
import type { Brand } from '../../types/Brand';
import styles from './BrandHeader.module.css';

interface Props {
  brand: Brand;
}

function Logo(props: Props) {
  const [error, setError] = useState(false);

  if (error) {
    return null;
  }

  return (
    <img 
      className={styles.logo}
      src={props.brand.images?.large} 
      onError={() => setError(true)}
    />
  );
}

export default Logo;
